module.exports = __webpack_public_path__ + "img/744.fc67831b.jpg";